import React, { useEffect, useState } from "react";
import { DeleteIcon, EditIcon } from "../../../images/icons/website-icons";
import Loader from "../../../components/ui/Loader";
import { useDispatch, useSelector } from "react-redux";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { toast } from "react-toastify";
import { showConfirmAlert } from "../../../components/components-react/ReactAlert";
import { useGetFetch, useGetFetchNew } from "../../../data/Queries";
import { earning_tasks } from "../../../data/ApiEndpoints";
import PaymentLinkTable from "../../../components/payment-link-system/PaymentLinkTable";
import { formatDate } from "../../../utils/utilityfunc";
import EarningUpdateForm from "./UpdateEarningTask";
import Modal from "react-modal";

const AllEarningTask = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(8);

  const {
    data: earningTasksData,
    isLoading,
    refetch,
    isFetching,
  } = useGetFetchNew({
    token: userInfoData?.token,
    key: "earning_tasks",
    url: `${earning_tasks}`,
    filters: {
      limit: pageLimit,
      page: page + 1,
    },
  });

  const [selectedRow, setSelectedRow] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  const tbColumns = [
    {
      dataField: "reference",
      text: "Task Name",
      formatter: (name, row) => {
        return <span className="tb-data">{row?.reference || "NA"}</span>;
      },
    },
    {
      dataField: "value",
      text: "Coins Reward",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.value || "NA"}</span>
        );
      },
    },
    {
      dataField: "value_inr",
      text: "Value (₹)",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.value_inr || "NA"}</span>
        );
      },
    },
    {
      dataField: "mode",
      text: "Mode",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.mode || "NA"}</span>;
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">{formatDate(row?.date_added) || "NA"}</span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <p className="tb-data">
            <span
              className={
                row?.status === "active" ? "greenColorBg" : "redColorBg"
              }
            >
              {row?.status || "NA"}
            </span>
          </p>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() => handleEdit(row)}
          >
            <EditIcon />
          </button>

          <button
            className="actionBtn icon delete"
            onClick={() => {
              const uidFilter = {
                uid: row?.uid || "",
              };
              handleDelete(uidFilter);
            }}
          >
            {deleteLoading ? <Loader /> : <DeleteIcon />}
          </button>
        </div>
      ),
    },
  ];

  const { loading: deleteLoading } = useSelector((state) => state.api);

  const handleEdit = (row) => {
    setSelectedRow(row);
    setIsEdit(true);
  };

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: "/delete",
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            refetch();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  return (
    <div className="allEarningTask">
      <h4>All Earning Modes</h4>

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
        {isLoading ? (
          <Loader />
        ) : (
          <PaymentLinkTable
            tableData={earningTasksData?.data}
            tableColumns={tbColumns}
            userInfoData={userInfoData}
            isPage={page}
            setIsPage={(value) => setPage(value)}
            isLoading={isLoading}
            tablePagination={earningTasksData?.pagination}
            setPageLimit={setPageLimit}
            pageLimit={pageLimit}
          />
        )}
      </div>
      <Modal
        isOpen={isEdit}
        onRequestClose={() => setIsEdit(false)}
        contentLabel="Edit Earning Task"
        ariaHideApp={false}
      >
        <EarningUpdateForm
          initialValues={selectedRow}
          isEdit={isEdit}
          closeModal={() => setIsEdit(false)}
          token={userInfoData?.token}
          getEarningTasks={refetch}
        />
      </Modal>
    </div>
  );
};

export default AllEarningTask;
